import { render } from "./GiftAidDeclarationRequest.vue?vue&type=template&id=5a78d266"
import script from "./GiftAidDeclarationRequest.vue?vue&type=script&lang=js"
export * from "./GiftAidDeclarationRequest.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__